import { useEffect } from "react";
import { toast } from "react-toastify";

import { useRealTimeTypedQuery } from "components/WebSocket/hooks";
import { typedQueryClient } from "hooks/useTypedQuery";
import { useLocationLicensesDashboardFilters } from "modules/LocationLicenseOverview/components/LocationLicenseFilters/hooks";
import { useLocationLicenseOverviewListeners } from "modules/LocationLicenseOverview/listeners";
import { LocationLicenseOverviewKeys } from "modules/LocationLicenseOverview/queryKeys";
import { transformData } from "modules/LocationLicenseOverview/utils";
import { ApiInstance } from "utils/Api";

export const useLicensesQuery = () => {
  const { location: selectedLocation } = useLocationLicensesDashboardFilters();
  const { listeners } = useLocationLicenseOverviewListeners({ selectedLocation });

  const query = useRealTimeTypedQuery({
    queryKey: LocationLicenseOverviewKeys.licenses,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { dealer_location_id: selectedLocation?.id }, baseUrl)).data,
    select: transformData,
    listeners,
    enabled: Boolean(selectedLocation?.id && selectedLocation.is_exact_invoicing_enabled)
  });

  useEffect(() => {
    if (selectedLocation?.id && selectedLocation.is_exact_invoicing_enabled) query.refetch();
    else if (!selectedLocation?.is_exact_invoicing_enabled) typedQueryClient.removeQueries(LocationLicenseOverviewKeys.licenses);
  }, [selectedLocation?.id]);

  useEffect(() => {
    if (query.error) toast.error(query.error.message);
  }, [query.error]);

  // TODO: Use a consistent approach throughout the codebase (we use few different approaches when exporting - in some cases we return the whole query object, some cases individually the data, the refetch function, etc.)
  return query;
};
